import { bool, func } from 'prop-types';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { UnfoldMore as UnfoldMoreIcon, UnfoldLess as UnfoldLessIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';

const useStyles = makeStyles({
    rotatedAction: {
        transform: 'rotate(45deg)',
    },
});

export default function MaximizeAction({ maximized, onChange }) {
    const classes = useStyles();
    return maximized ? (
        <Action
            id="collapse"
            icon={<UnfoldLessIcon className={classes.rotatedAction} />}
            tooltip={t`Restore`}
            onClick={() => onChange(false)}
        />
    ) : (
        <Action
            id="expand"
            icon={<UnfoldMoreIcon className={classes.rotatedAction} />}
            tooltip={t`Maximize`}
            onClick={() => onChange(true)}
        />
    );
}

MaximizeAction.propTypes = {
    maximized: bool,
    onChange: func,
};

MaximizeAction.defaultProps = {
    maximized: false,
    onChange: _.noop,
};
